import React from "react";
import { Container, Row, Col } from "reactstrap";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { PLATFORM_NAME } from "../../CommonData/Data/constant";

const Error500 = ({ t }) => {
  // Dynamic document title using translation
  document.title = t("document.title.500", { PLATFORM_NAME });

  return (
    <React.Fragment>
      <div className="my-5 pt-5">
        <div className="w-100">
          <Container>
            <Row className="justify-content-center">
              <Col lg={6} md={8} xl={5}>
                <div className="text-center">
                  <div>
                    <h1 className="display-2 error-text fw-bold">500</h1>
                  </div>
                  <div>
                    <h4 className="text-uppercase mt-4">
                      {t("error.500.heading")}
                    </h4>
                    <p>{t("error.500.message")}</p>
                    <div className="mt-4">
                      <Link to="/" className="btn btn-primary">
                        <i className="ri-arrow-left-line align-bottom mr-2"></i>{" "}
                        {t("error.500.button.backToHome")}
                      </Link>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(Error500);
